export default __webpack_public_path__ + "static/media/Announce.ebc75675.svg";